import * as React from "react";
import Dialog from "../../../../ui/widgets/dialog";
import Typography from "../../../../ui/widgets/typography";
import Button from "../../../../ui/widgets/button";
import { useMessageSource } from "react-message-source";

export default function ApplicationCanceledDialog({
  onDismiss,
}: {
  onDismiss: () => void;
}): React.JSX.Element {
  const { getMessage } = useMessageSource();

  return (
    <Dialog open={true} maxWidth="lg">
      <Typography variant="h2" className="scd-container-base">
        {getMessage("CancelApplication.cancel-dialog.title")}
      </Typography>
      <Typography variant="body1">
        {getMessage("CancelApplication.cancel-dialog.text")}
      </Typography>
      <div className="scd-dialog-footer">
        <Button onClick={() => onDismiss()} kind="primary">
          {getMessage("CancelApplication.cancel-dialog.button")}
        </Button>
      </div>
    </Dialog>
  );
}
